import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useAuth } from '../context/AuthContext';
import toast from 'react-hot-toast';

const LoginPage = () => {
  const { register, handleSubmit, formState: { errors } } = useForm();
  const { login } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const onSubmit = async (data) => {
    setLoading(true);
    const result = await login(data.username, data.password);
    
    if (result.success) {
      toast.success('Welcome to the Realms of Loria!');
      navigate('/characters');
    } else {
      toast.error(result.error);
    }
    setLoading(false);
  };

  return (
    <div className="auth-container">
      <form className="auth-form fade-in" onSubmit={handleSubmit(onSubmit)}>
        <h2>The Realms of Loria</h2>
        <p className="text-center mb-2" style={{ color: '#ccc' }}>
          Castle Antaria stands. The dungeon below it does not. Step into a world of card-driven combat, branching alignments, and a Founding Accord one battle from breaking.
        </p>

        <div className="form-group">
          <label htmlFor="username">Username</label>
          <input
            type="text"
            id="username"
            {...register('username', { required: 'Username is required' })}
            disabled={loading}
          />
          {errors.username && (
            <div className="error-message">{errors.username.message}</div>
          )}
        </div>

        <div className="form-group">
          <label htmlFor="password">Password</label>
          <input
            type="password"
            id="password"
            {...register('password', { required: 'Password is required' })}
            disabled={loading}
          />
          {errors.password && (
            <div className="error-message">{errors.password.message}</div>
          )}
        </div>

        <button 
          type="submit" 
          className="btn btn-primary"
          disabled={loading}
        >
          {loading ? 'Entering...' : 'Enter the Realm'}
        </button>

        <div className="text-center mt-2">
          <p style={{ color: '#ccc' }}>
            Don't have an account?{' '}
            <Link to="/register" style={{ color: '#839dbf' }}>
              Create one here
            </Link>
          </p>
        </div>
      </form>
    </div>
  );
};

export default LoginPage;
